import {
  normalizeStoreHostname,
  resolveRetailStoreContext,
} from '../storeDetails';
import { ALGOLIA_RULE_CONTEXT } from './constants';

const MAIN_SITE_HOSTS = new Set(['joybird.com', 'www.joybird.com']);

/**
 * Classifies a request's host for the `main_site` / `store_subdomain` rule
 * contexts (CON-8651): retail associates browse from a per-store subdomain,
 * ordinary shoppers from the marketing domain.
 *
 * A store is whatever resolveRetailStoreContext says is one — the same store
 * list and non-prod `storeHostName` cookie override that store pricing uses —
 * so `sf.joybird.com` and `sf.store.joybird.com` land in the same bucket.
 *
 * Both buckets are allowlists, mirroring isIndexableHost. Preview hosts,
 * `localhost` and anything else deliberately return null rather than defaulting
 * to `main_site`: a rule context changes the results Algolia serves, so
 * non-production traffic must not silently join the bucket production rules are
 * written against.
 *
 * @param {object} context
 * @param {string} [context.host] Hostname, with or without a port.
 * @param {string} [context.cookieStoreHostName] Honoured outside production.
 * @param {boolean} [context.isProduction]
 * @returns {'main_site'|'store_subdomain'|null}
 */
const getSiteRuleContext = ({
  host,
  cookieStoreHostName,
  isProduction,
} = {}) => {
  if (
    resolveRetailStoreContext({
      originalHost: host,
      cookieStoreHostName,
      isProduction,
    })
  ) {
    return ALGOLIA_RULE_CONTEXT.STORE_SUBDOMAIN;
  }

  if (MAIN_SITE_HOSTS.has(normalizeStoreHostname(host))) {
    return ALGOLIA_RULE_CONTEXT.MAIN_SITE;
  }

  return null;
};

export default getSiteRuleContext;
